/**
 * 事件通讯
 * https://www.npmjs.com/package/tiny-emitter
 */
import Emitter from 'tiny-emitter';
export const emitter = new Emitter();
export default emitter;

// 事件定义
export const EMIT_DEFINE = {
  wechatOa_qrcode_toOpen: 'wechatOa_qrcode_toOpen', //去打开公众号二维码
  wechatOa_qrcode_close: 'wechatOa_qrcode_close', //公众号二维码关闭事件
  //AI - chat
  ai_chat_open: 'ai_chat_open',
  //guodu
  gd_card_open: 'gd_card_open',

  // 观看有礼: 查看奖池
  watch_gift_look_jackpot: 'watch_gift_look_jackpot',
  // 观看有礼: 切换主视图填充内容（倒计时、即刻开启、中奖、未中奖、领奖页、中奖详情、中奖列表）
  watch_gift_change_mainfiller: 'watch_gift_change_mainfiller',
  // 观看有礼: 更新信息
  watch_gift_update_info: 'watch_gift_update_info',

  // 乐乐/直播带货模式，发起端定制侧边菜单点击
  live_sidemenu_change: 'live_sidemenu_change',
  live_lottery_setting: 'live_lottery_setting', // 打开or关闭抽奖设置
  live_lottery_setting_success: 'live_lottery_setting_success', // 抽奖设置成功（有保存成功的操作）
  live_exam_setting: 'live_exam_setting', // 打开or关闭快问快答设置
  live_exam_refresh: 'live_exam_refresh', // 快问快答列表刷新（创建和编辑成功后调用）

  // 标品 发起端
  watch_gift_main: 'watch_gift_main', // 打开or关闭观看有礼主对话框

  // 计时器发送事件
  duration_timeupdate: 'duration_timeupdate',
  // 互动工具"更多"里面和外面使用相同的图标组件，导致初始化两次; 解决方案："更多"里面只使用纯图标，点击时通过事件触发外侧图标组件的逻辑
  interact_tools_icon_click: 'interact_tools_icon_click',

  // 大小屏切换发送事件, 借助已知的7个视频相关组件上的切换逻辑，现在的业务场景这个7个组件切换按钮同一时间只有一个有效
  max_min_screen_exchange: 'max_min_screen_exchange',

  // 播放器播放
  player_start_play: 'player_start_play',
  player_vod_play_end: 'player_vod_play_end', //回放or点播播放完成

  // 现金红包 在线时长更新
  cash_redpacket_duration_update: 'cash_redpacket_duration_update',
  // 现金红包 自动判断相关弹窗
  cash_redpacket_open_popop: 'cash_redpacket_open_popop',
  // 现金红包 某一项信息更新
  cash_redpacket_update_info: 'cash_redpacket_update_info',
  // 现金红包: 切换主视图填充内容
  cash_redpacket_change_mainfiller: 'cash_redpacket_change_mainfiller',

  // 商城奖励 在线时长更新
  mall_reward_duration_update: 'mall_reward_duration_update',
  // 商城奖励 立即领取
  mall_reward_claim_now: 'mall_reward_claim_now',
  // 商城奖励 自动判断相关弹窗
  mall_reward_open_popop: 'mall_reward_open_popop',
  // 商城奖励 某一项信息更新
  mall_reward_update_info: 'mall_reward_update_info',
  // 商城奖励: 切换主视图填充内容
  mall_reward_change_mainfiller: 'mall_reward_change_mainfiller',

  // 不互动踢出功能使用
  do_like: 'do_like', // 执行点赞
  do_chat: 'do_chat', // 执行聊天

  // 邀请卡
  invite_card_open: 'invite_card_open',

  // tabs菜单项个数变化
  tab_menu_len_change: 'tab_menu_len_change',

  // 推屏卡片 - 取消推屏卡片
  push_card_cancel: 'push_card_cancel'
};
